// extracted by mini-css-extract-plugin
export var black = "_m-6";
export var brand = "_m-1";
export var ddefault = "_m-0";
export var error = "_m-3";
export var gray = "_m-2";
export var highContrast = "_m-8";
export var outline = "_m-7";
export var success = "_m-5";
export var warning = "_m-4";